import { setRange, setTerm } from '.';
import { TJsonQuery } from './types';

export function unsetUndergroundTravel(jsonQuery: TJsonQuery): () => TJsonQuery {
  return () => {
    const modifiedJsonQuery = setTerm('only_foot')(jsonQuery)(null);

    return setRange('foot_min')(modifiedJsonQuery)(null, null);
  };
}
